"use strict";

angular.module('PatientApp').controller('AccountDetailsCtrl', function ($scope, $rootScope) {
  $rootScope.newContent = true;
});